import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserPreference } from "../../shared/services/user-preference.service";
import { FormGroup } from "@angular/forms";
import { RequestService, SavedRequest, SprayBoothStudy } from "../../shared/services/request.service";
import { Observable } from "rxjs";
import { ExperimentDetailsFormBuilderService } from "../experiment-details/experiment-details-form/experiment-details-form-builder.service";
import { ExperimentDetailsFormModel } from "../services/request-form.service";
import { RequestFormModelService } from "../services/request-form-model.service";
import { CeSite } from "../../shared/services/ce-site.service";
import { Crop } from "../../shared/services/crop.service";
import { RequestPurpose } from "../../shared/services/request-purpose.service";
import { FacilityType } from "../../shared/services/facility-type.service";
import { ProductConcept } from "../../shared/services/product-concept.service";
import { PmoProgram } from "../../shared/services/pmo-program.service";
import { Substrate } from "../../shared/services/substrate.service";
import { IrrigationMethod } from "../../shared/services/irrigation-method.service";
import { FertigationMethod } from "../../shared/services/fertigation-method.service";
import { LightingInstruction } from "../../shared/services/lighting-instruction.service";
import { TemperatureInstruction } from "../../shared/services/temperature-instruction.service";
import { HumidityInstruction } from "../../shared/services/humidity-instruction.service";
import { PesticideInstruction } from "../../shared/services/pesticide-instruction.service";
import { PollinationCategory } from "../../shared/services/pollination-category.service";
import { ContainerDefinition } from "../../shared/services/container-definition.service";
import { CurrentUser } from "../../shared/services/current-user.service";
import { User } from "../../shared/services/user.service";
import { PollinationType } from "../../shared/services/pollination-type.service";
import { GrowthStage } from "../../shared/services/growth-stage.service";
import { Laboratory } from "../../shared/services/laboratory.service";
import { TissueType } from "../../shared/services/tissue-type.service";
import { ProjectedTaskConfiguration } from "../../shared/services/projected-task-configuration.service";
import { ActiveModel, AdjuvantModel, AdjuvantUnit, ApplicationTimepoint, ApplicationVolume, RateUnit } from "../../shared/services/spray-booth-study.service";


@Component({
  selector: "app-request-header",
  templateUrl: "./request-header.component.html",
  providers: [
    ExperimentDetailsFormBuilderService,
    RequestFormModelService
  ]
})
export class RequestHeaderComponent implements OnInit {
  private id: number;
  public ceRequestOptions: CeRequestOptions;
  public currentUser: CurrentUser;
  public experimentDetailsFormGroup: FormGroup;
  public saving: boolean = false;

  constructor(private route: ActivatedRoute,
    private requestFormService: ExperimentDetailsFormBuilderService,
    private requestService: RequestService,
    private router: Router,
    private modelService: RequestFormModelService) {
  }

  ngOnInit() {
    this.currentUser = this.route.snapshot.data['currentUser'];

    this.buildOptions();
    this.buildForm();
  }

  static selectListSorter = (
    i1: SelectListItem,
    i2: SelectListItem
  ): number => {
    return i1.name.localeCompare(i2.name);
  };

  private buildOptions = (): void => {
    this.ceRequestOptions = {
      userPreference: null,
      ceSites: [],
      crops: [],
      requestPurposes: [],
      facilityTypes: [],
      productConcepts: [],
      pmoPrograms: [],
      substrates: [],
      fertigations: [],
      irrigations: [],
      temperatureInstructions: [],
      humidityInstructions: [],
      lightingInstructions: [],
      pesticideInstructions: [],
      pollinationCategories: [],
      flatTypes: [],
      potTypes: [],
      users: [],
      growthStages: [],
      tissueTypes: [],
      actives: [],
      adjuvants: [],
      adjuvantUnits: [],
      applicationTimepoints: [],
      applicationVolumes: [],
      rateUnits: [],
      laboratories: [],
      pollinationTypes: [],
      projectedTaskConfigurations: []
    };

    this.ceRequestOptions = <CeRequestOptions>(
      this.route.snapshot.data["requestOptions"]
    );
  };

  private buildForm = (): void => {
    this.experimentDetailsFormGroup = this.requestFormService.build();
  };

  public save(): void {
    this.saveDetails()
      .subscribe(r => {
        this.id = r.id;
        this.router.navigate([`/requests/edit/${r.id}/details`]);
      });
  }

  public saveAndContinue(): void {
    this.saving = true;

    this.saveDetails()
      .subscribe(r => {
        this.id = r.id;
        this.router.navigate([`/requests/edit/${r.id}/design`])
      });
  }

  private saveDetails(): Observable<SavedRequest> {
    let model = this.experimentDetailsFormGroup.value as ExperimentDetailsFormModel;
    const apiModel = this.modelService.toDetailsApiModel(model);
    return this.requestService.saveDetails(apiModel);
  }
}

export interface SelectListItem {
  id: number;
  name: string;
}

export interface CeRequestOptions {
  userPreference: UserPreference;
  ceSites: CeSite[];
  crops: Crop[];
  requestPurposes: RequestPurpose[];
  facilityTypes: FacilityType[];
  productConcepts: ProductConcept[];
  pmoPrograms: PmoProgram[];
  substrates: Substrate[];
  irrigations: IrrigationMethod[];
  fertigations: FertigationMethod[];
  lightingInstructions: LightingInstruction[];
  temperatureInstructions: TemperatureInstruction[];
  humidityInstructions: HumidityInstruction[];
  pesticideInstructions: PesticideInstruction[];
  pollinationCategories: PollinationCategory[];
  flatTypes: ContainerDefinition[];
  potTypes: ContainerDefinition[];
  users: User[];
  pollinationTypes: PollinationType[];
  tissueTypes: TissueType[];
  growthStages: GrowthStage[];
  actives: ActiveModel[];
  adjuvantUnits: AdjuvantUnit[];
  adjuvants: AdjuvantModel[];
  applicationTimepoints: ApplicationTimepoint[];
  applicationVolumes: ApplicationVolume[];
  rateUnits: RateUnit[];
  laboratories: Laboratory[];
  projectedTaskConfigurations: ProjectedTaskConfiguration[];
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/request-header/request-header.component.ts